import React, { useEffect, useRef, useState } from 'react'
import { useFormValidator } from '../../effects/forms/useFormValidator'
import { ITask } from './Task'

/**
 * Properties for the edit task component
 */
export interface IEditTaskProps {
    task: ITask
    onCancel: () => void
    onSave: (task: ITask) => void
}

function EditTaskComponent(props: IEditTaskProps) {
    const nameInput = useRef<HTMLInputElement>(null)

    const [name, setName] = useState(props.task.name)
    const [description, setDescription] = useState(props.task.description)
    const validator = useFormValidator()

    useEffect(() => {
        if (nameInput && nameInput.current) nameInput.current.focus()
    }, [name])

    return (
        <form
            data-testid="edittask-form"
            noValidate
            onSubmit={(event) =>
                validator.handleSubmit(event, () => {
                    props.onSave({
                        ...props.task,
                        name,
                        description,
                    })
                    setName(props.task.name)
                    setDescription(props.task.description)
                    validator.reset()
                })
            }
            className={`card mb-2 ${validator.valid ? '' : 'was-validated'}`}>
            <div className="card-body">
                <div className="form-group">
                    <label htmlFor="edit-task-name">Name</label>
                    <input
                        type="text"
                        className="form-control"
                        id="edit-task-name"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        minLength={2}
                        required
                        ref={nameInput}></input>
                    <div
                        className="invalid-feedback"
                        aria-label="name input error feedback">
                        Please provide a name which is at least 2 character long
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="edit-task-description">Description</label>
                    <textarea
                        aria-label="Description"
                        className="form-control"
                        id="edit-task-description"
                        value={description}
                        onChange={(event) => setDescription(event.target.value)}
                        minLength={15}
                        required></textarea>
                    <div
                        className="invalid-feedback"
                        aria-label="description textbox error feedback">
                        Please provide a description which is at least 15
                        character long
                    </div>
                </div>
                <div>
                    <button
                        type="button"
                        className={`btn btn-secondary mr-1 btn-outline`}
                        onClick={props.onCancel}>
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </div>
        </form>
    )
}

export default EditTaskComponent
